import { isVisualizationCanvas } from 'common/views/view_types';
import { AudienceScope, View } from 'common/types/view';

/**
 * Takes response from /api/views/<4x4> and determines
 * whether or not the asset can change visibility.
 */
export function canChangeVisibility(coreView: Partial<View>, parentScope?: AudienceScope) {
  if (!isVisualizationCanvas(coreView)) {
    return true;
  }

  /**
   * Do not allow vizcans to have higher access scope than their parent
   */
  if (
    coreView.permissions?.scope == AudienceScope.Public &&
    (parentScope == AudienceScope.Site || parentScope == AudienceScope.Private)
  ) {
    /**
     * this view: public
     * parent view: site (internal) or private
     */
    return false;
  } else if (coreView.permissions?.scope == AudienceScope.Site && parentScope == AudienceScope.Private) {
    /**
     * this view: site (internal)
     * parent view: private
     */
    return false;
  }

  return true;
}
